export default __webpack_public_path__ + "static/media/icon-qa-active.38ced65d.svg";